export function themeDefinition(def) {
  return () => def;
}
//# sourceMappingURL=DesignToken.js.map